import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { MfaCredentialsDto } from '../../interfaces/mfa-credentials-dto';
import { envToken } from '../../tokens/env-token';

@Injectable({
    providedIn: 'root'
})
export class MfaCredentialService {
    private http = inject(HttpClient);
    private env = inject(envToken);

    private baseUrl = '';

    constructor() {
        this.baseUrl = this.env.apiUrl + '/api/v1/mfa-credentials';
    }

    getCredentials(ssoGuid: string): Observable<MfaCredentialsDto> {
        return this.http.get<MfaCredentialsDto>(`${this.baseUrl}/${ssoGuid}`);
    }

    removeCredential(ssoGuid: string, credentialId: string): Observable<void> {
        return this.http.delete<void>(`${this.baseUrl}/${ssoGuid}/${credentialId}`);
    }
}
